<template>
  <div>
    <Pos_my_order_list/>
  </div>
</template>

<script>
import Pos_my_order_list from "@/components/adminArin/pos_system/product/Pos_my_order_list";
export default {
  name: "PosMyOrderList",
  components: {
    Pos_my_order_list
  }
}
</script>

<style scoped>

</style>
